import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { FullClientInterface, IdInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class FullClientApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(clientCode: IdInterface, contractCode?: IdInterface): Observable<Transaction<FullClientInterface>> {
        return this.transactionRequest.wrap(this.apiClient.getFullClient(clientCode, contractCode));
    }

    update(client: FullClientInterface): Observable<Transaction<void>> {
        return new Observable((observer) => {
            this.transactionRequest.wrap(this.apiClient.updateFullClient(client)).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    observer.next(Transaction.success());
                } else {
                    observer.next(Transaction.error(transaction.error));
                }

                observer.complete();
            });
        });
    }
}
